import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class AccessDenied extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/common/get', {})
            .then(data => {

                if (data.status === 1) this.setState({ data, loading: false });

            })
            .catch(() => { });
    }

    renderForm() {
        return (
            <div className="nk-content-body">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                    <div className="card card-bordered text-center" style={{ maxWidth: '450px', width: '100%' }}>
                        <div className="card-inner">
                            <div className="mb-3">
                                <em className="icon ni ni-lock-alt" style={{ fontSize: '4rem', color: '#ef4444' }}></em>
                            </div>
                            <h4 className="card-title">دسترسی غیرمجاز</h4>
                            <p className="text-soft">
                                شما مجوز مشاهده این صفحه را ندارید.
                                <br />
                                در صورت نیاز با مدیر سیستم تماس بگیرید.
                            </p>
                            <NavLink to="/" className="btn btn-primary">
                                <em className="icon ni ni-home"></em> بازگشت به خانه
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            <Header data={this.state.data} />,
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        {this.renderForm()}
                    </div>
                </div>
            </div>,
            <Footer />
        ];
        return contents;
    }
}